export const ACTIONS = {
  UPDATE_TRACKING_DATA: 'updateTrackingData'
}

export const MUTATIONS = {
  SET_SESSION: 'setSession',
  SET_TEST: 'setTest',
  SET_SHOW_TEST_EVALUATION: 'setShowTestEvaluation'
}
